var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPills(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13513 7.37891H4.91892V9.2708C4.91892 10.3157 4.07189 11.1627 3.02702 11.1627C1.98216 11.1627 1.13513 10.3157 1.13513 9.2708V7.37891Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35757 6.43328L12.3305 10.4062C13.0873 10.0279 13.8441 7.94679 12.5197 6.62247C10.7644 4.86718 9.17739 5.73958 8.35757 6.43328Z",
    fill: "#FFB6BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2162 6.05506C8.85789 6.05506 7.75675 7.15619 7.75675 8.51452C7.75675 9.87284 8.85789 10.974 10.2162 10.974C11.5745 10.974 12.6757 9.87284 12.6757 8.51452C12.6757 7.15619 11.5745 6.05506 10.2162 6.05506ZM6.62161 8.51452C6.62161 6.52928 8.23097 4.91992 10.2162 4.91992C12.2014 4.91992 13.8108 6.52928 13.8108 8.51452C13.8108 10.4998 12.2014 12.1091 10.2162 12.1091C8.23097 12.1091 6.62161 10.4998 6.62161 8.51452Z",
    fill: "#FFB6BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.189178 4.73042C0.189178 3.16312 1.45972 1.89258 3.02702 1.89258C4.59431 1.89258 5.86485 3.16312 5.86485 4.73042V9.27096C5.86485 10.8383 4.59431 12.1088 3.02702 12.1088C1.45972 12.1088 0.189178 10.8383 0.189178 9.27096V4.73042ZM3.02702 3.02771C2.08664 3.02771 1.32431 3.79004 1.32431 4.73042V9.27096C1.32431 10.2113 2.08664 10.9737 3.02702 10.9737C3.96739 10.9737 4.72972 10.2113 4.72972 9.27096V4.73042C4.72972 3.79004 3.96739 3.02771 3.02702 3.02771Z",
    fill: "#FFB6BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPills);
export default __webpack_public_path__ + "static/media/ic-pills.c0748f41baaafd670a00666e23fbfee1.svg";
export { ForwardRef as ReactComponent };